import { render, staticRenderFns } from "./TacoRating.vue?vue&type=template&id=3d2b51a6&scoped=true&"
import script from "./TacoRating.vue?vue&type=script&lang=js&"
export * from "./TacoRating.vue?vue&type=script&lang=js&"
import style0 from "./TacoRating.vue?vue&type=style&index=0&id=3d2b51a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b51a6",
  null
  
)

export default component.exports